import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Users, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api, errorMessage } from "@/lib/api";

export function BulkAssignBar({ selected, onClear }) {
  const qc = useQueryClient();
  const [userId, setUserId] = useState("");
  const { data: team = [] } = useQuery({ queryKey: ["team"], queryFn: () => api.get("/team").then((r) => r.data) });
  const assign = useMutation({
    mutationFn: () => api.post("/tickets/bulk-assign", { ticket_ids: [...selected], user_id: userId }).then((r) => r.data),
    onSuccess: (d) => {
      toast.success(`${d.assigned} ticket${d.assigned === 1 ? "" : "s"} handed to ${d.assigned_to}${d.skipped ? ` · ${d.skipped} skipped (already taken)` : ""}`);
      onClear();
      qc.invalidateQueries({ queryKey: ["tickets"] });
      qc.invalidateQueries({ queryKey: ["stats"] });
    },
    onError: (e) => toast.error(errorMessage(e)),
  });
  if (!selected.size) return null;
  return (
    <div className="sticky bottom-3 z-30 mx-auto flex w-fit max-w-full flex-wrap items-center gap-3 rounded-2xl border-2 border-black bg-black px-4 py-3 text-white shadow-[6px_6px_0_#FACC15] fade-up" data-testid="bulk-assign-bar">
      <span className="inline-flex items-center gap-2 font-display text-base font-bold" data-testid="bulk-selected-count">
        <Users className="h-5 w-5 text-[#FACC15]" /> {selected.size} selected
      </span>
      <Select value={userId} onValueChange={setUserId}>
        <SelectTrigger className="h-10 w-56 rounded-xl border-2 border-white bg-black text-white" data-testid="bulk-assign-user-select">
          <SelectValue placeholder="Hand to…" />
        </SelectTrigger>
        <SelectContent>
          {team.filter((u) => !u.on_leave).map((u) => (
            <SelectItem key={u.id} value={u.id} data-testid={`bulk-assign-user-${u.id}`}>
              {u.name} <span className="text-xs text-zinc-500">· {u.role}</span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <button type="button" className="btn-primary !py-2" onClick={() => assign.mutate()} disabled={!userId || assign.isPending} data-testid="bulk-assign-submit">
        {assign.isPending ? "Assigning…" : `Assign ${selected.size}`}
      </button>
      <button type="button" className="rounded-full p-1 hover:bg-white/10" onClick={onClear} aria-label="Clear selection" data-testid="bulk-assign-clear">
        <X className="h-5 w-5" />
      </button>
    </div>
  );
}
